import { useOutletContext } from "react-router-dom";
import { IntegrationShell } from "../common/Shell";
import S3 from "V2.0/HomePages/HomeModule/S3Component";

export function S3Integration() {
  const { projectId, settings, fetchSettings, isViewOnly } = useOutletContext();

  return (
    <IntegrationShell>
      <S3
        projectId={projectId}
        settings={settings}
        fetchSettings={fetchSettings}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
